module.exports = __webpack_public_path__ + "img/6@s.5509db52.jpg";